import { createSlice } from "@reduxjs/toolkit";

const topPlanSlice = createSlice({
  name: "topPlan",
  initialState: { value: "" },
  reducers: {
    setTopPlan: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setTopPlan } = topPlanSlice.actions;
export default topPlanSlice.reducer;
